module.exports = __webpack_public_path__ + "img/rt-icon.b9cb9468.png";